package com.essntl.features.currency.ui.addcurrency.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.essntl.features.currency.domain.model.CurrencyModel
import com.essntl.uikit.components.checkbox.EsPrimaryCheckBox
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun CurrencyItem(
    currency: CurrencyModel,
    checked: Boolean,
    enabled: Boolean,
    onCheckedChange: (Boolean) -> Unit,
) {
    Row(
        horizontalArrangement = Arrangement.SpaceBetween,
        modifier = Modifier.fillMaxWidth(),
    ) {
        Text(
            text = "${currency.code} - ${currency.name}",
            color = if (enabled)
                MaterialTheme.esColorScheme.textPrimary else
                MaterialTheme.esColorScheme.textTertiary,
            style = MaterialTheme.esTypography.p2Medium14,
        )

        EsPrimaryCheckBox(
            checked = checked,
            enabled = enabled,
            onCheckedChange = onCheckedChange,
        )
    }
}